import {ROUTES} from "../constants";

export const isNewPersonalAreaPage = (pageRoute: string) => [
  ROUTES.ORDERS.MY,
  ROUTES.PROFILE.MY,
  ROUTES.PROJECTS.MY,
  ROUTES.NOTIFICATIONS,
].some((path) => pageRoute.startsWith(path))
